import { Borrow } from './actions/borrow';
import { ClaimCOMP } from './actions/claimCOMP';
import { EnterMarkets } from './actions/enterMarkets';
import { ExitMarket } from './actions/exitMarket';
import { Mint } from './actions/mint';
import { Redeem } from './actions/redeem';
import { RepayBorrow } from './actions/repayBorrow';
import { BorrowBalance } from './getters/borrowBalance';
import { CollateralFactor } from './getters/collateralFactor';
import { GetAccountLiquidity } from './getters/getAccountLiquidity';
import { GetAssetsIn } from './getters/getAssetsIn';
var actions = {
    Mint: Mint,
    Redeem: Redeem,
    Borrow: Borrow,
    RepayBorrow: RepayBorrow,
    EnterMarkets: EnterMarkets,
    ExitMarket: ExitMarket,
    ClaimCOMP: ClaimCOMP,
};
var getters = {
    GetAccountLiquidity: GetAccountLiquidity,
    CollateralFactor: CollateralFactor,
    BorrowBalance: BorrowBalance,
    GetAssetsIn: GetAssetsIn,
};
var CompoundV2 = {
    actions: actions,
    getters: getters,
};
export { CompoundV2 };
